"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkEJOOTMOY_js = require('./chunk-EJOOTMOY.js');
var chunkHBGNALKH_js = require('./chunk-HBGNALKH.js');
var chunkNSXTT2C2_js = require('./chunk-NSXTT2C2.js');
var chunk5XN3ONI2_js = require('./chunk-5XN3ONI2.js');
var chunkX5RGXUMZ_js = require('./chunk-X5RGXUMZ.js');
var chunk356JBGIO_js = require('./chunk-356JBGIO.js');
var chunkAC6LRJIW_js = require('./chunk-AC6LRJIW.js');
var chunk45FFMD6H_js = require('./chunk-45FFMD6H.js');
var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var react = require('react');
var g = require('styled-components');
var reactDayPicker = require('react-day-picker');
var react$1 = require('@floating-ui/react');
var dateFns = require('date-fns');
var faAngleLeft = require('@fortawesome/free-solid-svg-icons/faAngleLeft');
var faAngleRight = require('@fortawesome/free-solid-svg-icons/faAngleRight');
var jsxRuntime = require('react/jsx-runtime');
var faCalendarDays = require('@fortawesome/pro-regular-svg-icons/faCalendarDays');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var g__default = /*#__PURE__*/_interopDefaultLegacy(g);

var J=g__default["default"].div`
  display: inline-block;
  background: var(--background-level-2);
  box-shadow: var(--elevation-300);
  z-index: var(--z-index-200);
  border-radius: var(--border-radius-small);

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  table thead tr th {
    border-bottom: 1px solid var(--border-default);
    padding: var(--spacing-small) 0;
    background: var(--background-app);
    color: var(--foreground-tertiary);
    font-size: var(--font-size-small);
    line-height: 24px;
    text-transform: uppercase;
  }

  table tbody .rdp-cell {
    padding: 0;
  }

  table tbody tr:first-child td {
    padding-top: var(--spacing-x-small);
  }

  // Work around to add spacing to table body to match figma
  table thead.rdp-head {
    border-left: 16px solid var(--background-app);
    border-right: 16px solid var(--background-app);
    position: relative;
  }

  table thead.rdp-head::before,
  table thead.rdp-head::after {
    content: '';
    width: 16px;
    border-bottom: 1px solid var(--border-default);
    bottom: 0px;
    position: absolute;
    color: transparent;
  }

  table thead.rdp-head::before {
    left: -24px;
  }

  table thead.rdp-head::after {
    right: -24px;
  }

  table tbody.rdp-tbody {
    border: 16px solid transparent;
    border-top: none;
  }
`,he=g__default["default"].div`
  display: flex;
  justify-content: space-between;
  background: var(--background-app);
  padding: var(--spacing-regular) var(--spacing-regular) var(--spacing-small);
`,ye=g__default["default"].button`
  width: 44px;
  height: 40px;
  background: transparent;
  border: none;
  color: var(--foreground-primary);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: var(--border-radius-small);

  :hover {
    background: var(--background-boolean-hover);
  }

  &:focus-visible {
    outline-offset: 1px;
    outline-color: var(--border-link-focus);
    outline-width: var(--border-width-small);
  }

  ${e=>e.today&&`
    font-weight: bold;
  `}

  ${e=>e.outside&&`
    color: var(--foreground-tertiary);
  `}

  ${e=>e.selected&&`
    background: var(--border-boolean-active);
    color: var(--foreground-button-primary-hover);

    :hover {
      background: var(--border-boolean-active);
      color: var(--foreground-button-primary-hover);
    }
  `}

  &:disabled {
    background: var(--background-input-disabled);
    color: var(--foreground-disabled);
    cursor: not-allowed;
  }

  &.rdp-day_range_start {
    border-radius: var(--border-radius-small);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &.rdp-day_range_middle {
    background: var(--background-boolean-active);
    color: var(--foreground-boolean-active);
    border-radius: 0;
  }

  &.rdp-day_range_end {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  // Work around to show border radius on the first selected
  // day when it's a range
  &.rdp-day_range_start.rdp-day_range_end {
    border-radius: var(--border-radius-small);
  }
`,De=g__default["default"].div`
  min-width: 4px;
  min-height: 4px;
  border-radius: var(--border-radius-large);
  background-color: ${e=>e.selected?"var(--foreground-button-primary-hover)":"var(--border-boolean-active)"};
`,ve=g__default["default"](chunkEJOOTMOY_js.a)`
  width: 106px;
`,Me=g__default["default"](chunkEJOOTMOY_js.a)`
  width: 98px;
`,ke=g__default["default"].div`
  display: flex;
  padding: var(--spacing-regular);
`,xe=g__default["default"](chunk356JBGIO_js.a).attrs({spacing:"small"})`
  padding: var(--spacing-regular) var(--spacing-regular) 0 0;
`,Pe=g__default["default"](chunk356JBGIO_js.a).attrs({spacing:"regular"})`
  border-left: ${e=>e.leftBorder?"var(--border-width-x-small) solid var(--border-default)":"none"};
  padding: ${e=>e.leftBorder?"var(--spacing-regular) 0 var(--spacing-small) var(--spacing-regular)":"0"};
`,de=g__default["default"](chunk356JBGIO_js.a).attrs({spacing:"small"})`
  width: 162px;
`;function $e(e,t){return function(){let{goToMonth:o,nextMonth:r,previousMonth:s}=reactDayPicker.useNavigation(),{fromDate:p,toDate:i}=reactDayPicker.useDayPicker();return !p||!i?null:jsxRuntime.jsxs(he,{children:[jsxRuntime.jsx(chunk5XN3ONI2_js.a,{disabled:!s,onClick:()=>s&&o(s),iconOnly:!0,variant:"tertiary",children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faAngleLeft.faAngleLeft})}),e,t,jsxRuntime.jsx(chunk5XN3ONI2_js.a,{disabled:!r,onClick:()=>r&&o(r),iconOnly:!0,variant:"tertiary",children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faAngleRight.faAngleRight})})]})}}var j=$e;function Xe({date:e,displayMonth:t}){var r,s,p,i,c,f,b,h,P;let a=react.useRef(null),o=reactDayPicker.useDayRender(e,t,a);return jsxRuntime.jsxs(ye,{type:"button",name:"day",outside:(s=(r=o.activeModifiers)==null?void 0:r.outside)!=null?s:!1,selected:(i=(p=o.activeModifiers)==null?void 0:p.selected)!=null?i:!1,today:(f=(c=o.activeModifiers)==null?void 0:c.today)!=null?f:!1,ref:a,...o.buttonProps,children:[o.buttonProps.children,((b=o.activeModifiers)==null?void 0:b.today)&&jsxRuntime.jsx(De,{selected:(P=(h=o.activeModifiers)==null?void 0:h.selected)!=null?P:!1})]})}var U=Xe;var Ze=(e,t)=>{let a=[],o=e.getFullYear(),r=t.getFullYear();for(let s=o;s<=r;s++)a.push(dateFns.setYear(dateFns.startOfYear(new Date),s));return a};function V(){let{fromDate:e,toDate:t}=reactDayPicker.useDayPicker(),{displayMonths:a,goToMonth:o}=reactDayPicker.useNavigation();if(!e||!t)return null;let r=Ze(e,t),s=i=>{let c=dateFns.setYear(dateFns.startOfMonth(a[0]),Number(i));o(c);},p=a[0].getFullYear().toString();return jsxRuntime.jsx(Me,{onValueChange:s,defaultValue:p,children:r.map(i=>jsxRuntime.jsx(chunkEJOOTMOY_js.b,{value:i.getFullYear().toString(),label:i.getFullYear().toString()},i.getFullYear()))})}var at=(e,t)=>{let a=[];if(dateFns.isSameYear(e,t)){let o=dateFns.startOfMonth(e);for(let r=e.getMonth();r<=t.getMonth();r++)a.push(dateFns.setMonth(o,r));}else {let o=dateFns.startOfMonth(new Date);for(let r=0;r<=11;r++)a.push(dateFns.setMonth(o,r));}return a};function K({forwardedRef:e}){let{fromDate:t,toDate:a,locale:o}=reactDayPicker.useDayPicker(),{displayMonths:r,goToMonth:s}=reactDayPicker.useNavigation();if(!t||!a)return null;let p=at(t,a),i=f=>{let b=Number(f),h=dateFns.setMonth(dateFns.startOfMonth(r[0]),b);s(h);},c=r[0].getMonth().toString();return jsxRuntime.jsx(ve,{onValueChange:i,value:c,ref:e,children:p.map(f=>jsxRuntime.jsx(chunkEJOOTMOY_js.b,{value:f.getMonth().toString(),label:dateFns.format(f,"MMM",{locale:o})},f.getMonth()))})}var k="MM/dd/y",bt=e=>{if(!(e.from&&(e==null?void 0:e.to)))return "";let t="MMM d, yyyy",a=dateFns.format(e.from,t),o=dateFns.format(e.to,t);return `${a} - ${o}`},ht=react.forwardRef(({locale:e,initialValue:t,onChange:a,fromYear:o,toYear:r,fromMonth:s,toMonth:p,fromDay:i=new Date(1950,0,1),toDay:c=new Date(2050,11,31),inputProps:f={},placeholder:b,internalInputPlaceholder:h="MM/DD/YYYY",showPresets:P=!0},te)=>{var me;let B=react.useRef(null),[d,y]=react.useState(t),[S,C]=react.useState(t!=null&&t.from?dateFns.format(t.from,k):""),[T,H]=react.useState(t!=null&&t.to?dateFns.format(t.to,k):""),[O,A]=react.useState(!1),{refs:W,floatingStyles:oe,context:re}=react$1.useFloating({open:O,onOpenChange:A,placement:"bottom-start",middleware:[react$1.offset(20),react$1.shift(),react$1.flip()],whileElementsMounted:react$1.autoUpdate}),N=react.useRef(null),ae=react$1.useDismiss(re),{getReferenceProps:$,getFloatingProps:ne}=react$1.useInteractions([ae]),se=()=>A(!0),D=j(jsxRuntime.jsx(K,{forwardedRef:N}),jsxRuntime.jsx(V,{})),m=[];m.push({before:i,after:c});let F=n=>{y(n),C(n!=null&&n.from?dateFns.format(n.from,k):""),H(n!=null&&n.to?dateFns.format(n.to,k):""),n!=null&&n.to&&a(n);},Ie=d?bt(d):"",_e=n=>{C(n.currentTarget.value);let w=dateFns.parse(n.currentTarget.value,k,new Date,{locale:e}),u=d==null?void 0:d.to;if(T){let I=dateFns.parse(T,k,new Date,{locale:e});dateFns.isValid(I)&&(u=I);}dateFns.isValid(w)&&(!u||dateFns.isBefore(w,u))?y({from:w,to:u}):y({from:void 0,to:u});},He=n=>{H(n.currentTarget.value);let w=dateFns.parse(n.currentTarget.value,k,new Date,{locale:e}),u=d==null?void 0:d.from;if(S){let I=dateFns.parse(S,k,new Date,{locale:e});dateFns.isValid(I)&&(u=I);}dateFns.isValid(w)&&(!u||dateFns.isAfter(w,u))?y({from:u,to:w}):y({from:u,to:void 0});};return jsxRuntime.jsxs("div",{ref:B,children:[jsxRuntime.jsx(chunkNSXTT2C2_js.a,{type:"text",size:"regular",value:Ie,onChange:()=>{},ref:W.setReference,onClick:se,onFocus:se,name:"datepicker","aria-label":"datepicker",placeholder:b,maxLength:0,...f,...$()}),O&&jsxRuntime.jsx(chunkHBGNALKH_js.a,{children:jsxRuntime.jsx(J,{style:oe,ref:W.setFloating,...ne(),children:jsxRuntime.jsxs(ke,{children:[P?jsxRuntime.jsxs(xe,{children:[jsxRuntime.jsx(chunk45FFMD6H_js.d,{weight:"bold",colorToken:"foreground-primary",children:"Presets"}),jsxRuntime.jsxs(chunk356JBGIO_js.a,{spacing:"regular",children:[jsxRuntime.jsx(chunk5XN3ONI2_js.a,{variant:"secondary",onClick:()=>F({from:dateFns.startOfDay(dateFns.sub(new Date,{days:6})),to:dateFns.startOfDay(new Date)}),children:"Last 7 days"}),jsxRuntime.jsx(chunk5XN3ONI2_js.a,{variant:"secondary",onClick:()=>F({from:dateFns.startOfDay(dateFns.sub(new Date,{days:29})),to:dateFns.startOfDay(new Date)}),children:"Last 30 days"}),jsxRuntime.jsx(chunk5XN3ONI2_js.a,{variant:"secondary",onClick:()=>F({from:dateFns.startOfDay(dateFns.sub(new Date,{days:59})),to:dateFns.startOfDay(new Date)}),children:"Last 60 days"}),jsxRuntime.jsx(chunk5XN3ONI2_js.a,{variant:"secondary",onClick:()=>F({from:dateFns.startOfDay(dateFns.sub(new Date,{days:89})),to:dateFns.startOfDay(new Date)}),children:"Last 90 days"})]})]}):null,jsxRuntime.jsxs(Pe,{leftBorder:P,children:[jsxRuntime.jsxs(chunkX5RGXUMZ_js.a,{spacing:"regular",children:[jsxRuntime.jsxs(de,{children:[jsxRuntime.jsx(chunkAC6LRJIW_js.a,{children:"Start"}),jsxRuntime.jsx(chunkNSXTT2C2_js.a,{value:S,onChange:_e,placeholder:h})]}),jsxRuntime.jsxs(de,{children:[jsxRuntime.jsx(chunkAC6LRJIW_js.a,{children:"End"}),jsxRuntime.jsx(chunkNSXTT2C2_js.a,{value:T,onChange:He,placeholder:h})]})]}),jsxRuntime.jsx(reactDayPicker.DayPicker,{showOutsideDays:!0,initialFocus:!0,mode:"range",selected:d,defaultMonth:(me=d==null?void 0:d.from)!=null?me:new Date,onSelect:F,captionLayout:"dropdown-buttons",fromYear:o,toYear:r,fromMonth:s,toMonth:p,fromDate:i,toDate:c,disabled:m,components:{Caption:D,Day:U},locale:e})]})]})})})]})}),Te=ht;var ue="MM/dd/y",Et=react.forwardRef(({locale:e,initialValue:t,onChange:a,fromYear:o,toYear:r,fromMonth:s,toMonth:p,fromDay:i=new Date(1950,0,1),toDay:c=new Date(2050,11,31),inputProps:f={},placeholder:b="MM/DD/YYYY"},h)=>{let P=react.useRef(null),[te,B]=react.useState(t),[d,y]=react.useState(t?dateFns.format(t,ue):""),[S,C]=react.useState(!1),{refs:T,floatingStyles:H,context:O}=react$1.useFloating({open:S,onOpenChange:C,placement:"bottom-start",middleware:[react$1.offset(20),react$1.shift(),react$1.flip()],whileElementsMounted:react$1.autoUpdate}),A=react.useRef(null),W=react$1.useDismiss(O),{getReferenceProps:oe,getFloatingProps:re}=react$1.useInteractions([W]),N=()=>C(!0),ae=j(jsxRuntime.jsx(K,{forwardedRef:A}),jsxRuntime.jsx(V,{})),$=[];$.push({before:i,after:c});let ne=(D,m)=>{B(m),C(!1),a(m),y(dateFns.format(m,ue));};return jsxRuntime.jsxs("div",{ref:P,children:[jsxRuntime.jsx(chunkNSXTT2C2_js.a,{type:"text",size:"regular",value:d,onChange:D=>{y(D.currentTarget.value);let m=dateFns.parse(D.currentTarget.value,ue,new Date,{locale:e});dateFns.isValid(m)?(B(m),a(m)):B(void 0);},ref:T.setReference,name:"datepicker","aria-label":"datepicker",placeholder:b,action:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faCalendarDays.faCalendarDays,onClick:N,colorToken:"foreground-secondary","aria-label":"Click to open date picker"}),onKeyDownAction:D=>{["Enter","Space"].includes(D.code)&&(D.preventDefault(),N());},...f,...oe()}),S&&jsxRuntime.jsx(chunkHBGNALKH_js.a,{children:jsxRuntime.jsx(J,{style:H,ref:T.setFloating,...re(),children:jsxRuntime.jsx(reactDayPicker.DayPicker,{showOutsideDays:!0,initialFocus:!0,mode:"single",selected:te,defaultMonth:te,onSelect:ne,captionLayout:"dropdown-buttons",fromYear:o,toYear:r,fromMonth:s,toMonth:p,fromDate:i,toDate:c,disabled:$,components:{Caption:ae,Day:U},locale:e})})})]})}),Le=Et;var Fe=react.forwardRef((e,t)=>e.variant==="range"?jsxRuntime.jsx(Te,{...e}):jsxRuntime.jsx(Le,{...e}));Fe.displayName="DatePicker";var Ft=g__default["default"](Fe)``;

exports.a = Ft;
